import React, { useState, useEffect } from 'react';
import { useAppStore } from '../store/useAppStore';
import { api } from '../services/api';
import { CloudIcon, CloudSlashIcon, MapPinIcon, ServerIcon, GlobeAltIcon } from './Icons';
import { useNavigate, Link } from 'react-router-dom';

const Header: React.FC = () => {
  const { seller, setSeller, resetProducts, userLocation, setAuthModalOpen } = useAppStore();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const navigate = useNavigate();

  useEffect(() => {
    const updateStatus = () => setIsOnline(navigator.onLine);
    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);
    return () => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    };
  }, []);

  const handleLogout = async () => {
    await api.auth.logout();
    setSeller(null);
    resetProducts();
    navigate('/');
  };

  return (
    <header className="bg-nav-bg/95 backdrop-blur-md border-b border-nav-border shadow-card sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <h1 className="text-2xl font-black text-nav-text tracking-tight">
              AgriConnect
            </h1>
            <p className="text-[10px] font-black text-app-text-accent uppercase tracking-widest leading-none">Farm Marketplace</p>
          </Link>
          <div className="flex items-center gap-1.5 ml-2">
              <div className={`p-1.5 rounded-full ${isOnline ? 'bg-brand-green-50' : 'bg-error-bg'}`} title={isOnline ? "Online" : "Offline"}>
                {isOnline ? <CloudIcon className="w-4 h-4 text-brand-green" /> : <CloudSlashIcon className="w-4 h-4 text-error-text" />}
              </div>
              {userLocation && (
                  <div className="p-1.5 rounded-full bg-brand-yellow-100" title="Location Enabled">
                      <MapPinIcon className="w-4 h-4 text-brand-brown" />
                  </div>
              )}
          </div>
        </div>
        <div className="flex items-center gap-4 md:gap-8">
            <nav className="hidden sm:flex items-center gap-6">
              <Link 
                to="/map" 
                className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-app-text-secondary hover:text-nav-text transition-colors"
                title="Map View"
              >
                <GlobeAltIcon className="w-4 h-4" />
                Find Nearby
              </Link>
            </nav>
            {seller ? (
              <div className="flex flex-col items-end">
                <span className="text-app-text text-xs font-bold leading-none">{seller.name}</span>
                <div className="flex items-center gap-3 mt-1">
                  <Link 
                    to="/admin" 
                    className="text-[10px] font-black uppercase tracking-tighter text-nav-text hover:text-brand-green-hover flex items-center gap-1 transition-colors"
                    title="System Dashboard"
                  >
                    <ServerIcon className="w-3 h-3" />
                    Admin
                  </Link>
                  <button 
                      onClick={handleLogout}
                      className="text-[10px] font-black uppercase tracking-tighter text-app-text-secondary hover:text-nav-text transition-colors"
                  >
                      Logout
                  </button>
                </div>
              </div>
            ) : (
              <button 
                onClick={() => setAuthModalOpen(true)}
                className="rounded-lg bg-btn-primary px-3 py-1.5 text-xs font-bold text-btn-primary-text hover:bg-btn-primary-hover transition-colors"
              >
                Login
              </button>
            )}
        </div>
      </div>
    </header>
  );
};

export default Header;
